import MapNav from "@components/map/map_nav/MapNav"
import store from './store/store.js'
import LandslideIcon from '@images/landslide_icon.png'
import RadarIcon from '@images/radar_icon.png'

export default function MapNavbarController(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this

    let navItems =
        [
            {icon: '', id:'landslide', title: 'Risco de Deslizamentos', show_on:['plu']},
            {icon: '<i class="fas fa-bolt"></i>', id:'lightning', title: 'Exibir Raios', show_on:['plu', 'flu']},
            
        ]
    

    this.generate = () =>{
        
    }

    this.update = () =>{

    }

    const prepareIcon = url =>{
        let img = new Image()
        $(img).css({filter: "brightness(0) invert(1)", width: '17px'})
        img.src = url
        return img.outerHTML
    }

    init()

    function init(){
        let landslide_icon = prepareIcon(LandslideIcon)
        let radar_icon = prepareIcon(RadarIcon)
        navItems[0].icon = landslide_icon        

        if(CAN_SEE_RADAR_DAEE){
            navItems.push({icon: '', id:'radar_daee', title: 'Risco de Deslizamentos', show_on:['plu','flu']})
            navItems[2].icon = radar_icon
        }


        let mapNav = new MapNav({map:map, options:{icons:{show_title: true}}, position:{position: 'topright', orientation: 'vertical'}, navItems:[]})
        mapNav.generate()

        mapNav.on('nav-item-click', navItem=>{

            if(navItem.id === 'landslide'){
                let active = store.landslideConfigStore.getOption('active')
                store.landslideConfigStore.setOption('active', !active)
                mapNav.itemActive('landslide', !active)
                navItem.active = !active
            } else if(navItem.id === 'radar_daee'){
                let active = store.timelineConfigStore.getOption('active')
                store.timelineConfigStore.setOption('active', !active)
                mapNav.itemActive('radar_daee', !active)
                navItem.active = !active
            } else if(navItem.id === 'lightning'){
                let active = store.lightningConfigStore.getOption('active')
                store.lightningConfigStore.setOption('active', !active)
                mapNav.itemActive('lightning', !active)
                navItem.active = !active
            }
        })

        store.mainConfigStore.subscribe('TYPE_UPDATE', type=>{
            mapNav.updateNavItems(navItems.filter(x=>x.show_on.includes(type)))
        })
    }
}

MapNavbarController.prototype = Object.create(BaseConstructor.prototype)